(() => {
  'use strict';
  const sessions = new WeakMap();
  const wait = (milliseconds, signal) => new Promise((resolve, reject) => {
    if (signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
    const abort = () => { clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError')); };
    const timer = setTimeout(() => { signal.removeEventListener('abort', abort); resolve(); }, milliseconds);
    signal.addEventListener('abort', abort, { once: true });
  });
  function clear(shell) {
    const session = sessions.get(shell);
    if (session) session.dispose();
    sessions.delete(shell);
  }
  async function mount(container, { data, product, shell, variantId }) {
    clear(shell);
    const C = window.DSVWeekend, esc = C.escape;
    const weekend = C.event(data, product.eventId), park = C.location(data, weekend.locationId);
    const url = new URL(product.url, location.origin);
    if (url.origin !== location.origin) {
      container.textContent = 'Dit productformulier kon niet worden geopend. Neem contact met ons op.';
      return;
    }
    const previewId = new URLSearchParams(location.search).get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' ? String(window.Shopify?.theme?.id || '') : '');
    if (/^\d+$/.test(previewId)) url.searchParams.set('preview_theme_id', previewId);
    const fallback = url.href;
    url.searchParams.set('view', 'dsv-weekend-data');
    const controller = new AbortController();
    let disposeOptions, observer, poll, timeout, clickReset, dirty = false, ready = false, live = true;
    let form, slot, button, variant, clickAuthorised = false;
    container.innerHTML = `<div class="booking-product"><img src="${esc(product.image)}" alt="${esc(product.title)}" width="320" height="240" loading="lazy"><div><span class="eyebrow">Jullie weekend is gevonden</span><h4>${esc(product.title)}</h4><p>${esc(C.dateRange(weekend))}<br>${esc(park.name)}</p><span class="pill green">${esc({basic:'Basic · spelen in je eigen huisje',complete:'Complete · spelletjesruimte inbegrepen',included:'Spelletjesruimte inbegrepen'}[product.package])}</span></div></div><p class="dsvw-form-loading" role="status">We laden het boekingsformulier van jullie huisje…</p><div class="dsvw-native-mount" aria-busy="true"></div><p class="dsvw-form-fallback" hidden><a href="${esc(fallback)}" target="_blank" rel="noopener" data-dsv-weekend-keep-product-link>Open het productformulier apart ↗</a></p><p class="booking-note">Je boekt één huisje. Controleer de gekozen opties en het totaal in de winkelwagen voordat je afrekent.</p>${park.conditionsUrl ? `<p class="booking-note"><a href="${esc(park.conditionsUrl)}" target="_blank" rel="noopener">Bekijk de voorwaarden voor dit weekend ↗</a></p>` : ''}`;
    const status = container.querySelector('[role=status]');
    const fallbackNote = container.querySelector('.dsvw-form-fallback');
    const host = container.querySelector('.dsvw-native-mount');
    const warn = message => { status.hidden = false; status.textContent = message; };
    const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    function fieldsReady() {
      return live && !!variant?.available && typeof disposeOptions === 'function' &&
        typeof window.TPOConfigs?.actions?.validateOptionSet === 'function' &&
        !!slot?.querySelector('[data-option-set-id]') &&
        !!slot?.querySelector('input:not([type=hidden]),select,textarea,[role=combobox]');
    }
    function checkReady() {
      const next = fieldsReady();
      if (next === ready) return;
      ready = next;
      button.disabled = !ready;
      host.setAttribute('aria-busy', String(!ready));
      if (ready) { status.hidden = true; fallbackNote.hidden = true; clearTimeout(timeout); }
      else warn('Wacht even tot het boekingsformulier volledig is geladen.');
    }
    function canSubmit() {
      if (!fieldsReady()) { warn('Het boekingsformulier is nog niet volledig geladen.'); return false; }
      try {
        if (!window.TPOConfigs.actions.validateOptionSet({ formElement: form })) {
          warn('Controleer de gemarkeerde velden en vul alle verplichte gegevens in.');
          return false;
        }
      } catch (_) { warn('De ingevulde gegevens konden niet worden gecontroleerd. Open het productformulier apart.'); fallbackNote.hidden = false; return false; }
      if (!form.reportValidity()) return false;
      status.hidden = true;
      return true;
    }
    // Registered before Easify renders: unloaded or invalid forms never reach its cart handler.
    function guardClick(event) {
      if (!button || !button.contains(event.target)) return;
      if (!canSubmit()) { stop(event); return; }
      clickAuthorised = true;
      clearTimeout(clickReset);
      clickReset = setTimeout(() => { clickAuthorised = false; }, 0);
      // Easify now handles paid add-ons, properties and its own cart-transform logic.
    }
    function guardSubmit(event) {
      if (event.target !== form) return;
      if (!canSubmit()) { stop(event); return; }
      if (!clickAuthorised) {
        // Also route keyboard/requestSubmit through Easify's normal button-click handler.
        stop(event);
        button.click();
      }
      // A normal validated submit is a native Shopify POST. No second Ajax add-to-cart.
    }
    function markDirty(event) { if (slot?.contains(event.target)) dirty = true; }
    function confirmChange(event) {
      if (!dirty || !event.target.closest('[data-back],[data-step],[data-restart],[data-other-house],#dsvw-reset')) return;
      if (!window.confirm('Je hebt al gegevens ingevuld. Bij het wijzigen van je keuze wordt dit formulier leeggemaakt. Wil je doorgaan?')) stop(event);
    }
    const session = { dispose() {
      live = false; controller.abort(); observer?.disconnect(); clearInterval(poll); clearTimeout(timeout); clearTimeout(clickReset);
      window.removeEventListener('click', guardClick, true);
      shell.removeEventListener('click', confirmChange, true);
      host.removeEventListener('submit', guardSubmit, true);
      host.removeEventListener('input', markDirty); host.removeEventListener('change', markDirty);
      if (typeof disposeOptions === 'function') disposeOptions();
    } };
    sessions.set(shell, session);
    window.addEventListener('click', guardClick, true);
    shell.addEventListener('click', confirmChange, true);
    host.addEventListener('submit', guardSubmit, true);
    host.addEventListener('input', markDirty); host.addEventListener('change', markDirty);
    timeout = setTimeout(() => {
      if (!ready && live) { warn('Het boekingsformulier heeft wat langer nodig. Je kunt het ook via het product openen.'); fallbackNote.hidden = false; }
    }, 15000);
    try {
      // Fetch only current product data; no iframe, copied app scripts or stored option prices.
      const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw Error('Product request failed');
      const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const json = fragment.querySelector('script[data-dsv-weekend-product]');
      if (!json) throw Error('Product data view missing');
      const productData = JSON.parse(json.textContent), currentProduct = productData.product;
      if (productData.version !== 1 || String(currentProduct?.id) !== String(product.productId) || !Array.isArray(currentProduct.variants)) throw Error('Product identity mismatch');
      if (!live) return;
      variant = currentProduct.variants.find(v => String(v.id) === String(variantId || productData.selectedVariantId) && v.available) || currentProduct.variants.find(v => v.available);
      if (!variant) {
        host.setAttribute('aria-busy', 'false'); clearTimeout(timeout);
        warn('Dit huisje is inmiddels niet meer beschikbaar. Ga een stap terug en kies een ander huisje.');
        return;
      }
      const action = new URL(productData.cartAddUrl, location.origin);
      if (action.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add$/.test(action.pathname)) throw Error('Invalid cart URL');
      const productId = String(currentProduct.id);
      const money = cents => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: productData.currency || 'EUR' }).format(cents / 100);
      const variants = currentProduct.variants.length > 1 ? `<label class="dsvw-variant-label" for="dsvw-variant">Uitvoering</label><select id="dsvw-variant" class="dsvw-variant">${currentProduct.variants.map(v => `<option value="${esc(v.id)}" ${String(v.id) === String(variant.id) ? 'selected' : ''} ${v.available ? '' : 'disabled'}>${esc(v.title)} — ${esc(money(v.price))}${v.available ? '' : ' (uitverkocht)'}</option>`).join('')}</select>` : '';
      host.innerHTML = `<article id="main-product" class="dsvw-native-product"><h4>Jullie gegevens & extra’s</h4><p>Vul jullie gegevens in en kies de extra’s voor jullie verblijf.</p>${variants}<div class="easify easify-product-options" data-product-id="${esc(productId)}"></div><form id="main-product-form-${esc(productId)}" class="dsvw-booking-form" action="${esc(action.pathname)}" method="post" enctype="multipart/form-data" data-dsv-weekend-keep-form><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${esc(variant.id)}"><input type="hidden" name="quantity" value="1"><div class="dsvw-booking-total"><span data-price-label>Prijs bij je gekozen opties</span><p class="price"><strong class="price-product">${esc(money(variant.price))}</strong></p><small>Inclusief btw. Controleer alle gegevens en kosten in je winkelwagen.</small></div><button class="button yellow dsvw-add-to-cart" type="submit" name="add" disabled>In winkelwagen <span aria-hidden="true">→</span></button></form></article>`;
      form = host.querySelector('form'); slot = host.querySelector('.easify-product-options'); button = form.querySelector('button[type=submit]');
      host.querySelector('.dsvw-variant')?.addEventListener('change', event => {
        const selected = event.target.value;
        if (dirty && !window.confirm('Bij een andere uitvoering worden de ingevulde gegevens gewist. Wil je doorgaan?')) { event.target.value = String(variant.id); return; }
        // A fresh form also removes the previous option set and its product context.
        mount(container, { data, product, shell, variantId: selected });
      });
      const deadline = Date.now() + 15000;
      while (typeof window.TPORenderOptionSet !== 'function' || typeof window.TPOConfigs?.actions?.validateOptionSet !== 'function') {
        if (Date.now() >= deadline) throw Error('Easify app unavailable');
        await wait(150, controller.signal);
      }
      if (!live) return;
      const changesPrice = ['1', 'true', 'active'].includes(String(window.TPOConfigs.settings?.changeProductPrice).toLowerCase());
      if (!changesPrice) form.querySelector('[data-price-label]').textContent = 'Huisjeprijs — toeslagen staan bij de opties';
      // Public renderer exposed by the enabled Easify app embed; cleanup is provided by Easify.
      disposeOptions = window.TPORenderOptionSet(slot, {
        ...currentProduct, id: productId, collection_ids: productData.collectionIds || []
      }, variant, form);
      observer = new MutationObserver(checkReady);
      observer.observe(slot, { childList: true, subtree: true });
      poll = setInterval(checkReady, 300);
      checkReady();
    } catch (error) {
      if (!live || error.name === 'AbortError') return;
      if (button) button.disabled = true;
      ready = false; clearTimeout(timeout); host.setAttribute('aria-busy', 'false');
      warn('Het boekingsformulier kon hier niet volledig worden geladen. Je kunt je boeking via het productformulier afronden.');
      fallbackNote.hidden = false;
      console.error('DSV weekend: boekingsformulier niet beschikbaar');
    }
  }
  window.DSVWeekendBooking = { mount, clear };
})();
